const contentTypeJson = "application/json";
const apiAppUser = "/api/appUser";
const apiStar = apiAppUser + "/star";

const login = function(emailAddress, password) {
  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": contentTypeJson },
    mode: "cors",
    body: JSON.stringify({ emailAddress, password }),
  };

  return fetch(apiAppUser + "/login", requestOptions)
    .then(handleResponse)
    .then((user) => {
      if (user.token && user.mfa === false) {
        localStorage.setItem("user", JSON.stringify(user));
      }
      return user;
    });
};

const verifyMfa = function(payload) {
  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": contentTypeJson },
    mode: "cors",
    body: JSON.stringify(payload),
  };

  return fetch(apiAppUser + "/verifyMfa", requestOptions)
    .then(handleMfaResponse)
    .then((user) => {
      if (user.token) {
        localStorage.setItem("user", JSON.stringify(user));
      }
      return user;
    });
};

const resendMfa = function() {
  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": contentTypeJson },
    mode: "cors",
  };

  return fetch(apiAppUser + "/resendMfa", requestOptions)
    .then(handleMfaResponse)
    .then(() => {
      return;
    });
};

const logout = function() {
  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": contentTypeJson },
    mode: "cors",
  };

  return fetch(apiAppUser + "/logout", requestOptions)
    .then(handleResponse)
    .then(() => {
      return;
    });
};

const signup = function(pendingUser) {
  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": contentTypeJson },
    mode: "cors",
    body: JSON.stringify(pendingUser),
  };

  return fetch(apiAppUser + "/register", requestOptions)
    .then(handleResponse)
    .then((data) => {
      return data;
    });
};

const testToken = function(token) {
  const requestOptions = {
    method: "GET",
    headers: { "Content-Type": contentTypeJson },
    mode: "cors",
  };
  const queryUrl =
    apiAppUser + "/testToken?type=" + token.type + "&token=" + token.token;

  return fetch(queryUrl, requestOptions)
    .then(handleResponse)
    .then((email) => {
      return email;
    })
    .catch((err) => {
      console.error("Unable to fetch email from token: ", err);
    });
};

const registerAndAccept = function(pendingUser) {
  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": contentTypeJson },
    mode: "cors",
    body: JSON.stringify(pendingUser),
  };

  return fetch(apiAppUser + "/registerAndAccept", requestOptions)
    .then(handleResponse)
    .then((resp) => {
      if (resp.user.token && resp.user.mfa === false) {
        localStorage.setItem("user", JSON.stringify(resp.user));
      }
      return resp;
    })
    .catch((err) => {
      console.error("Unable to register and accept user: ", err);
      if (err === "Field 'new password' is not a valid password") {
        return Promise.reject("badPw");
      }
      return Promise.reject(err);
    });
};

const current = function() {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": contentTypeJson,
    },
    mode: "cors",
  };

  return fetch(apiAppUser + "/me", requestOptions)
    .then(handleResponse)
    .then((userInfo) => {
      return userInfo;
    });
};

const update = function(user) {
  const requestOptions = {
    method: "PUT",
    headers: {
      "Content-Type": contentTypeJson,
    },
    mode: "cors",
    body: JSON.stringify(user),
  };

  return fetch(apiAppUser, requestOptions)
    .then(handleResponse)
    .then((userInfo) => {
      return userInfo;
    });
};

const verify = function(lookupToken) {
  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": contentTypeJson },
    mode: "cors",
    body: JSON.stringify({ lookupToken }),
  };

  return fetch(apiAppUser + "/verify", requestOptions)
    .then(handleResponse)
    .then((user) => {
      return user;
    });
};

const forgotPassword = function(emailAddress) {
  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": contentTypeJson },
    mode: "cors",
    body: JSON.stringify({ emailAddress }),
  };

  return fetch(apiAppUser + "/forgotPassword", requestOptions)
    .then(handleResponse)
    .then((res) => {
      return res;
    });
};

const resetPassword = function(lookupToken, password) {
  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": contentTypeJson },
    mode: "cors",
    body: JSON.stringify({ lookupToken, password }),
  };

  return fetch(apiAppUser + "/resetPassword", requestOptions)
    .then(handleResponse)
    .then((user) => {
      return user;
    });
};

const getNotification = function() {
  const requestOptions = {
    method: "GET",
    headers: { "Content-Type": contentTypeJson },
    mode: "cors",
  };

  return fetch(apiAppUser + "/notification", requestOptions)
    .then(handleResponse)
    .then((notificationList) => {
      return notificationList;
    });
};

const getStar = function(projectId) {
  const requestOptions = {
    method: "GET",
    headers: { "Content-Type": contentTypeJson },
    mode: "cors",
  };

  return fetch(apiStar + "/" + projectId, requestOptions)
    .then(handleResponse)
    .then((star) => {
      return star;
    });
};

const getStars = function() {
  const requestOptions = {
    method: "GET",
    headers: { "Content-Type": contentTypeJson },
    mode: "cors",
  };

  return fetch(apiStar, requestOptions)
    .then(handleResponse)
    .then((stars) => {
      return stars;
    });
};

const addStar = function(projectId) {
  const requestOptions = {
    method: "GET",
    headers: { "Content-Type": contentTypeJson },
    mode: "cors",
  };

  return fetch(apiStar + "/" + projectId + "/add", requestOptions)
    .then(handleResponse)
    .then((star) => {
      return star;
    });
};

const deleteStar = function(projectId) {
  const requestOptions = {
    method: "GET",
    headers: { "Content-Type": contentTypeJson },
    mode: "cors",
  };

  return fetch(apiStar + "/" + projectId + "/delete", requestOptions)
    .then(handleResponse)
    .then((star) => {
      return star;
    });
};

const handleResponse = function(resp) {
  return resp.text().then((text) => {
    let data;
    try {
      data = text && JSON.parse(text);
    } catch (e) {
      data = e;
    }
    if (!resp.ok) {
      if (resp.status === 503) {
        localStorage.removeItem("user");
        location.replace("/maintenance");
      }

      if (resp.status === 403) {
        localStorage.removeItem("user");
        location.replace("/login");
      }

      const err = (data && data.message) || resp.statusText;
      return Promise.reject(err);
    }

    return data;
  });
};

const handleMfaResponse = function(resp) {
  return resp.text().then((text) => {
    let data;
    try {
      data = text && JSON.parse(text);
    } catch (e) {
      data = e;
    }
    if (!resp.ok) {
      if (resp.status === 503) {
        localStorage.removeItem("user");
        location.replace("/maintenance");
      }

      if (resp.status === 403) {
        localStorage.removeItem("user");
        location.replace("/login?err=auth_expired");
      }

      const err = (data && data.message) || resp.statusText;
      return Promise.reject(err);
    }

    return data;
  });
};

export const userService = {
  login,
  logout,
  signup,
  testToken,
  registerAndAccept,
  current,
  update,
  verify,
  verifyMfa,
  resendMfa,
  forgotPassword,
  resetPassword,
  getNotification,
  getStar,
  getStars,
  addStar,
  deleteStar,
};
